import { BasicTable } from "@synergy/table";
import { Col, Flex, Row } from "antd";
import i18next from 'i18next';
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useAuthContext } from "../../../../../../contexts/AuthContext";
import query from "../../../../../../server/constants.api";
import logger from "../../../../../../server/server";
import useFetch from "../../../../../../server/useFetch";
import Theme from "../../../../../../styles/Theme/Theme";
import { NoData } from "../../../../Atomics/NoData";
import Spinner from "../../../../Atomics/Spinner";
import { Widget } from "../../../../Atomics/Widget";

const CustomTable = styled.div`
  .antd-basic-table {
    .ant-table {
      border-color: #e6f7ff;
    }

    .ant-table-thead > tr > th {
      background: transparent;
      color: ${Theme.color["green-deloitte"]};
    }

    .ant-table-thead > tr:hover > th {
      background: transparent;
      color: ${Theme.color["green-deloitte"]};
    }
  }
`;

export const BuildingIncidents = ({ item }) => {
  // Obtém a função de tradução do hook useTranslation
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  useEffect(() => {
    logger.info("User " + user?.Username + " entered BuildingIncidents successfully! Tenant: " + tenant);
  }, [])

  const { data: overviewIncidents, isFetching: overviewIncidentsIsFetching } = useFetch("/registry/incidents", "overviewIncidents",
    {
      tenant: item?.tenant,
    }, item?.tenant ?? false, null, query.middlewareURL);


  return (
    <Row style={{ width: "100%", margin: "0px" }} gutter={[16, 16]}>
      <Col span={24} style={{ alignContent: "center" }}>
        <Row>
          <Col span={10}>
            <Row>
              <Col span={24}>
                <h3>
                  {item?.name} |  {t("Incidents").toUpperCase()}{" "}
                  {/* Changes the title to upperCase and translates it */}
                </h3>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {/* {currentFloor ? <> */}
      <Col span={12}>
        <Widget
          data={{
            background: "white",
            title: t("Current Incidents"),
            icon: null,
            border: "neutral-3",
            charts: [
              {
                chartType: "simpleDonutChartApex",
                chartId: "donutChartOne",
                height: "200px",
                isFetching: overviewIncidentsIsFetching,
                data: overviewIncidents?.incidentsByPriority ? generateIncidentsByPriority(overviewIncidents?.incidentsByPriority) : null,
              },
            ],
          }}
        />
      </Col>
      <Col span={12}>
        <Widget
          data={{
            background: "white", // Define o fundo como transparente
            title: t("Top 5 Incidents"), // Título do Widget traduzido
            icon: null, // Nenhum ícone definido
            border: 'neutral-3',
            charts: [
              {
                chartType: "topListChart", // Tipo de gráfico definido como lista de topo
                chartId: "bigNumberChartOne", // ID do gráfico
                height: "200px", // Altura do gráfico
                isFetching: overviewIncidentsIsFetching,
                data: overviewIncidents?.top5incidents ? Object.entries(overviewIncidents?.top5incidents).map((entry) => {
                  const [key, value] = entry;
                  return { name: key, color: 'black' };
                }) : null,
              }
            ],
          }}
        />
      </Col>
      <Col span={24}>
        <Widget
          data={{
            background: "white", // Define o fundo do widget como branco
            title: t("Incident List"), // Título do widget traduzido
            height: '200px'
          }}
        >
          {!overviewIncidentsIsFetching ?
            overviewIncidents?.incidents ? (
              <CustomTable>
                <BasicTable
                  tableId="buildingsEventsTable"
                  language={i18next.resolvedLanguage}
                  fetchData={overviewIncidents?.incidents.map(x => {
                    x.openDate = x.openDate.replace("T", " ");
                    const decodedBase64 = atob(x.description);
                    return { ...x, description: decodedBase64 };
                  })}
                  hidePagination={true}
                />
              </CustomTable>) :
              (<div
                style={{
                  height: "inherit",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                { }
                <NoData />
              </div>)
            :
            <Flex justify="center" align="center" style={{ height: '200px' }}>
              <Spinner stroke="green" size="42px" />
            </Flex>}
        </Widget>
      </Col>
      {/* </> : null} */}
    </Row>
  )
};

const generateIncidentsByPriority = (data) => {
  const result = [];
  Object.entries(data).forEach(entry => {
    const [key, value] = entry;
    result.push({ name: key, value: value });
  })

  return {
    "series": result,
    "categories": null,
    "tooltip": null,
    "markerSize": 3,
    "unit": "ui",
    "columnWidth": 20,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "categorias",
    "total": " ",
    "disableTotal": false,
    "sideLegend": true,
    "dataLabelsOffset": 30,
    "customScale": 0.9
  }
}